import { loadOverlay } from '../../../utils'
type OverlayRecord = {
  // 标识当前浮层显隐状态
  open?: boolean,
  // 浮层最新接收到的数据，可用于onReady内部消费
  data?: any,
  onShow: () => {},
  onHide: () => {},
  onReceiveData: () => {},
}

class OverlayManager {
  constructor() {
    // 浮层内部逻辑执行完毕后的事件
    window.addEventListener("appendedOverlay", () => {
      this._openOverlay(this._id, this._data)
    })
  }
  private _id
  private _data
  // 缓存Overlay的数据，如生命周期、显隐状态
  public overlayRecord = new Map<string, OverlayRecord>()
  private static _instance: OverlayManager
  static getInstance = (): OverlayManager => {
    if (!this._instance) {
      this._instance = new OverlayManager()
    }
    return this._instance
  }

  public getDomById = (id: string): HTMLElement | null => {
    const _target = document.getElementById(id)
    return _target
  }

  private _openOverlay = (id, data) => {
    // 重新获取
    const target = this.overlayRecord.get(id)
    const _overlayDom = this.getDomById(`overlay_${id}`)
    if (_overlayDom) {
      _overlayDom.style.display = 'block'
    }


    // 保证onReady先执行，因为onReady也被setTimeout包装了
    setTimeout(() => {
      target.data = data
      // 浮层处于隐藏状态时才执行onShow，已经显示的情况下不需要执行onShow
      if (!target.open) {
        target.onShow?.()
      }
      target.onReceiveData?.()
      target.open = true
    }, 0)
  }

  public show = (id, data) => {
    this._id = id
    this._data = data
    // 检索缓存中的目标对象
    let target = this.overlayRecord.get(id)
    if (!target) {
      // 加载浮层
      loadOverlay(id)
    } else {
      this._openOverlay(id, data)
    }
  }
  public hide = (id) => {
    // 检索缓存中的目标对象
    let target = this.overlayRecord.get(id)
    if (!target) {
      return
    }
    // 如果浮层已经隐藏了，则不需要再调用hide相关的逻辑
    if (!target.open) {
      return
    }
    const _overlayDom = this.getDomById(`overlay_${id}`)
    if (_overlayDom) {
      _overlayDom.style.display = 'none'
    }
    target.open = false
    target.onHide?.()
  }
  public getReceivedData = (id: string) => {
    let target = this.overlayRecord.get(id)
    return target?.data
  }
  public setRecordData = (id: string, data: any) => {
    if (id && data && typeof data === 'object') {
      let target = this.overlayRecord.get(id)
      this.overlayRecord.set(id, { ...target, ...data })
    }
  }
}

export const overlayManager = OverlayManager.getInstance()